/* Already Loved Club — cart capture (Layer 2/3 of abandoned-cart recovery).

   Two jobs:
   1. Report cart state to the flows service on every cart change, attaching the
      shopper's email when we know it (scratcher / footer newsletter / the
      drawer's "save your rack" field). Shopify's carts/* webhooks carry no
      email, so this report is the ONLY way an abandoned pre-checkout cart can
      ever be recovered by email.
   2. Run the drawer's "save your rack" field — shown for any non-empty bag when
      we don't already have an email. (Was gated to 2+ pieces / $200+ until
      2026-08-02: in 5 days only 5 shoppers ever qualified and 0 real ones
      filled it, so the gate was collecting nothing.)

   The drawer calls window.__alcCartCapture.onCart(cart) from its render(), so
   every add/change/remove and the on-load prime flows through here without a
   second /cart.js fetch. No {% form 'customer' %} and no /contact fetch — both
   are known traps on this store. */
(function () {
  'use strict';

  var LS = 'alc_email';
  var API = 'https://app.cynthiaconcierge.com/alc-flows/cart-touch';
  var SAVE_MIN_ITEMS = 1;
  var SAVE_MIN_CENTS = 20000;

  function getEmail() {
    try { return localStorage.getItem(LS) || ''; } catch (e) { return ''; }
  }
  function setEmail(v) {
    v = String(v || '').trim().toLowerCase();
    if (v.indexOf('@') < 1 || v.length > 254) return false;
    try { localStorage.setItem(LS, v); } catch (e) {}
    reportSoon();
    return true;
  }
  function ph(ev, props) {
    try { if (window.posthog && window.posthog.capture) window.posthog.capture(ev, props || {}); } catch (e) {}
  }

  /* ---- cart reporting ---- */

  var lastCart = null;
  var timer = null;

  function reportSoon() { clearTimeout(timer); timer = setTimeout(report, 800); }

  function report() {
    var go = function (cart) {
      if (!cart || !cart.token) return;
      var body = {
        cart_token: cart.token,
        email: getEmail() || null,
        item_count: cart.item_count,
        subtotal_cents: cart.items_subtotal_price,
        currency: cart.currency,
        line_items: (cart.items || []).map(function (i) {
          return {
            variant_id: i.id, product_id: i.product_id, quantity: i.quantity,
            title: i.product_title, price: i.price, image_url: i.image, handle: i.handle
          };
        })
      };
      try {
        fetch(API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
          keepalive: true
        }).catch(function () {});
      } catch (e) {}
    };
    if (lastCart) { go(lastCart); return; }
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(go).catch(function () {});
  }

  /* ---- "save your rack" drawer field ---- */

  var shownOnce = false;

  function syncSaveBlock(cart) {
    var block = document.querySelector('[data-cd-save]');
    if (!block) return;
    var qualifies = cart && cart.item_count > 0 &&
      (cart.item_count >= SAVE_MIN_ITEMS || cart.items_subtotal_price >= SAVE_MIN_CENTS);
    var show = qualifies && !getEmail();
    block.hidden = !show;
    if (show && !shownOnce) {
      shownOnce = true;
      ph('cart_email_shown', { item_count: cart.item_count, subtotal_cents: cart.items_subtotal_price });
    }
  }

  function onCart(cart) {
    lastCart = cart;
    syncSaveBlock(cart);
    reportSoon();
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;

    // The drawer's own save form: no navigation, no Shopify form.
    if (f.hasAttribute && f.hasAttribute('data-cd-saveform')) {
      e.preventDefault();
      var inp = f.querySelector('input[type="email"]');
      if (!inp || !setEmail(inp.value)) {
        if (inp) inp.classList.add('cd-savebad');
        return;
      }
      inp.classList.remove('cd-savebad');
      f.hidden = true;
      var done = document.querySelector('[data-cd-savedone]');
      if (done) done.hidden = false;
      var block = document.querySelector('[data-cd-save]');
      if (block) setTimeout(function () { block.hidden = true; }, 4000);
      ph('cart_email_saved', {
        item_count: lastCart ? lastCart.item_count : null,
        subtotal_cents: lastCart ? lastCart.items_subtotal_price : null
      });
      return;
    }

    // Any Shopify customer form (scratcher, footer newsletter): remember the
    // email as it submits, then let the native post proceed untouched.
    var el = f.querySelector('input[name="contact[email]"]');
    if (el && el.value) setEmail(el.value);
  }, true);

  window.__alcCartCapture = { onCart: onCart, setEmail: setEmail, getEmail: getEmail, report: report };

  // On-load report when we already know the shopper: catches "email captured
  // after the cart was built" and keeps last-activity honest across visits.
  if (getEmail()) reportSoon();
})();
